const getOrganizationIdFromPathBody = (): string | undefined => {
  const { pathname } = globalThis.location
  if (pathname.startsWith('/o/')) {
    return pathname.split('/')[2]
  }
  return undefined
}

export const getOrganizationIdFromPath = (): string => {
  if (process.env.NODE_ENV === 'test') {
    // eslint-disable-next-line sonarjs/todo-tag
    // TODO
    return '1'
  }

  const id = getOrganizationIdFromPathBody()
  if (id === undefined) {
    return ''
  }

  return id
}
